import React , {useEffect,useState,useRef} from 'react'
import { Link } from 'react-router-dom';
import Skeleton from '../skelton';

const GallHalfSection = ({formatData,format,catLink,mobile}) => {

                     const [data,setData] = useState(formatData)
                     const [loading,setLoading] = useState(false)
                     const [error,setError]= useState(null)
                     const isFirstLoad = useRef(true);
                    
             
                    
                       useEffect(() =>  {
                    
                            if (format === 'Actors')  {
                    
                                     if (data && isFirstLoad.current) {
                                            isFirstLoad.current = false;
                                             return;
                                        }
                                         setLoading(true)
                                      
                                        const fetchData = async () => {
                                        try {
                                        const res = await fetch("https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=2&start=0&limit=6");
                                        if (!res.ok) throw new Error(`API Response Was Not Ok`)
                                        const data = await res.json();
                                        setData(data.photosHomeByType || '');
                                    
                                      } catch (e) {
                                        console.error("Fetch error:", e);
                                        setError(e.message)
                                       }finally {
                                        setLoading(false)
                                      }
                                    };
                    
                                    fetchData(); 
                              
                            }
                           
                            
                             else {
                    
                                     if (data && isFirstLoad.current) {
                                            isFirstLoad.current = false;
                                             return;
                                        }
                                         setLoading(true)
                                    
                                        const fetchData = async () => {
                                        try {
                                        const res = await fetch("https://teluguone.com/photos_api/photosLatestByTypeJson?galTypeId=8&start=0&limit=6");
                                        if (!res.ok) throw new Error(`API Response Was Not Ok`)
                                        const data = await res.json();
                                     
                                        setData(data.photosHomeByType || '');
                                    
                                      } catch (e) {
                                        console.error("Fetch error:", e);
                                        setError(e.message)
                                       }finally {
                                        setLoading(false)
                                      }
                                    };
                    
                                    fetchData(); 
                    
                             }
                    
                       }, [format])
                    
                   
                        


  

  return (
   
       

         
          <section className="gallery-section half">


            <div className="section-header">
              <h2 className="section-title"><Link to={catLink} >{format}</Link></h2>
              <Link to={catLink} className="see-all">View All →</Link>
            </div>


            {((loading  || error)) &&
               <div className="gallery-card-main">
              <Link to="" >
                 <Skeleton type="gallery-card-main-img" />
                <div className="card-info">
                  <h3>{format}</h3>
                  <span className="card-link">See More →</span>
                </div>
              </Link>
            </div>
              
            
            
            }
            {((loading  || error)) &&  <ul className="compact-list">  
                {[0,0].map((item,index) => <li key={index}>
               <Link to="">
                  <Skeleton type="compact-list-img" />
                  <div style={{marginTop:'10px'}}><h4>{format}</h4><span>See More...</span></div>
                </Link>
                </li> ) }
            </ul>
            
              
            
            
            }

             
              
            {data && <div className="gallery-card-main">
              <Link to={(data?.[1]?.url_link  ? data?.[1]?.url_link.substring(data?.[1]?.url_link.indexOf('/photos')+7) :""  )}>
                <img src={data?.[1]?.stimg || ''} alt={data?.[1]?.title || ''} loading="lazy" />
                <div className="card-info">
                  <h3>{data?.[1]?.title || ''}</h3>
                  <span className="card-link">See More →</span>
                </div>
              </Link>
            </div>}

            {data && <ul className="compact-list">  
                {data?.slice(2,mobile ? 5 : 4)?.map((item,index) => <li key={index}>
               <Link to={(item.url_link  ? item.url_link.substring(item.url_link.indexOf('/photos')+7) :""  )}>
                  <img src={item.stimg || ''} alt={item.title || ''} loading="lazy" />
                  <div style={{marginTop:'10px'}}><h4>{item.title || ''}</h4><span>See More...</span></div>
                </Link>
                </li> ) }
            </ul>}


          </section>

        
         

        
     )


}

export default GallHalfSection;

